// export const FRONT_URL = "https://shortx.netlify.app";
// export const FRONT_URL = "http://localhost:3000";
export const FRONT_URL = "https://shortx.ml";
